@if(stroked){

<div [ngClass]="class">
  <button
    mat-stroked-button
    [color]="color"
    [disabled]="disabled || loading"
    [ngClass]="innerClass"
    (click)="onClick($event)"
    style="width: max-content"
  >
    <div
      class="d-flex align-items-center gap-1 w-fit-content"
      [ngClass]="iconSide == 'left' ? '' : 'flex-row-reverse'"
    >
      <svg-icon
        class="inner-icon"
        *ngIf="srcIcon"
        [src]="srcIcon || 'assets/icons/plus-circle-white.svg'"
      ></svg-icon>
      <mat-spinner
        [diameter]="20"
        [color]="'warn'"
        *ngIf="loading"
      ></mat-spinner>
      <div class="fs-13 fw-4">{{ text }}</div>
      <svg-icon
        class="inner-icon"
        *ngIf="srcIcon2"
        [src]="srcIcon2 || 'assets/icons/plus-circle-white.svg'"
      ></svg-icon>
    </div>
  </button>
</div>
} @else {
<div [ngClass]="class">
  <button
    mat-flat-button
    [color]="color"
    [disabled]="disabled || loading"
    [ngClass]="innerClass"
    (click)="onClick($event)"
    style="width: max-content"
  >
    <div
      class="d-flex align-items-center gap-1 w-fit-content"
      [ngClass]="iconSide == 'left' ? '' : 'flex-row-reverse'"
    >
      <mat-spinner
        [diameter]="20"
        [color]="'warn'"
        *ngIf="loading"
      ></mat-spinner>
      <svg-icon
        class="inner-icon"
        *ngIf="srcIcon"
        [src]="srcIcon || 'assets/icons/plus-circle-white.svg'"
      ></svg-icon>
      <div class="fs-13 fw-4">{{ text }}</div>
      <svg-icon
        class="inner-icon"
        *ngIf="srcIcon2"
        [src]="srcIcon2 || 'assets/icons/plus-circle-white.svg'"
      ></svg-icon>
    </div>
  </button>
</div>
}
